<template>
	<CContainer fluid :class="['container-filter', 'sticky-with-body-scroll-left', ...wrapperClass]">
		<CRow class="container-filter-header">
			<!-- Slot Header -->
			<slot name="header"></slot>
			<div :class="['container-filter-header-action', containerActionClass]">
				<CRow>
					<div class="container-filter-header-action-right">
						<!-- Filter Button -->
						<CButton
							:color="filterButtonColor"
							block
							class="filter-btn"
							@click="toggle"
						>
							<CIcon
								size="lg"
								name="cil-filter"
								class="mr-2"
							/>
							{{ $t('button.filter') }}
						</CButton>
					</div>
					<CCol class="container-filter-header-action-custom">
						<slot name="action"></slot>
					</CCol>
				</CRow>
			</div>
		</CRow>
		<CCollapse :show="collapse">
			<CRow v-if="bodyWithRow" class="container-filter-body">
				<!-- Slot Body -->
				<slot name="body"></slot>
			</CRow>
			<div v-else class="container-filter-body">
				<!-- Slot Body -->
				<slot name="body"></slot>
			</div>
		</CCollapse>
		<CRow class="container-filter-footer">
			<!-- Slot Footer -->
			<slot name="footer"></slot>
		</CRow>
	</CContainer>
</template>

<script>
export default {
	name: 'BaseSearchFilter',

	props: {
		active: {
			type: Boolean,
			default: false,
		},
		show: {
			type: Boolean,
			default: false,
		},
		containerActionClass: {
			type: String,
			default: null,
		},

		/**
		 * Default filter body will act as a row, most of the time you'll need only 1 row for filters.
		 * In case you need a multi-row filters, set it to false and put the row inside slot.
		 */
		bodyWithRow: {
			type: Boolean,
			default: true,
		},
	},

	data() {
		return {
			collapse: false,
		};
	},

	computed: {
		wrapperClass() {
			return [
				{ 'active-filters': this.active && !this.collapse },
			];
		},
		filterButtonColor() {
			return this.collapse
				? 'secondary'
				: 'tertiary';
		},
	},

	watch: {
		show(newVal) {
			this.collapse = newVal;
		},
	},

	created() {
		this.collapse = this.show;
	},

	methods: {
		toggle() {
			// do not collapse if slot body is not set
			if (this.$slots.body !== undefined) {
				this.collapse = !this.collapse;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.container-filter {
	padding: 0;

	// if filter is active, the red dot color will be show on the top right
	&.active-filters {
		.container-filter-header .filter-btn::after {
			display: block;
		}
	}

	// .container-filter-header
	&-header {
		// .container-filter-header-action
		&-action {
			&-right {
				width: 100%;
				padding-left: 12px;
				padding-right: 12px;
			}

			&.adjust-column {
				.container-filter-header-action-right {
					width: 118px;
					padding: 0 4px 0 16px;
				}
			}

			min-width: rem(90);
			margin-right: rem(12);

			button {
				position: relative;
				height: rem(35);
				box-shadow: none;

				&::after {
					display: none;
					content: "";
					position: absolute;
					top: 0;
					right: 0;
					width: rem(12);
					height: rem(12);
					background-color: $color-alert;
					border-radius: 50%;
					transform: translate(50%, -50%);
				}
			}
		}
	}

	// .container-filter-body
	&-body {
		padding: rem(16) rem(4);
		margin: 0 0 rem(12) 0;
		background-color: $color-gray-100;
		border-radius: rem(4);
	}

	// .container-filter-footer
	&-footer {
		display: flex;
		justify-content: space-between;
		align-items: baseline;
		font-size: rem(14);

		div {
			&:first-child {
				color: $color-black-75;
			}

			&:last-child {
				text-align: right;

				button {
					border: none;
					background: none;
					color: $color-hypertext;
					outline: none;
				}
			}
		}
	}
}
</style>
